const $openModal = $('.js-hero--open-modal');
const $openModalLink = $('.js-hero--open-modal');
const id = 'seb-hero-video';

const addEmbed = () => {
    const videoID = $('.hero__modal').attr("data-youtubeid");
    const url = `https://player.cvm3.se/${videoID}?fetch=true`;
    $('.hero__modal__frame')
    .append(`
        <iframe
            title="Video"
            id='${id}'
            width='560'
            height='315'
            src='${url}'
            frameborder='0'
            allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
            allowfullscreen
        >
        </iframe>
    `);
}

const openModal = () => {
    var popup = new Foundation.Reveal($('.hero__modal'));
    popup.open();

    $('.reveal-overlay').on('click', closeModal);
}

const closeModal = () => {
    $(`#${id}`).remove();
}

const events = () => {
    $openModalLink.on('click', addEmbed)
    $openModal.on('click', openModal);
}

const init = () => {
  events();
}

export default init;
